<template>
  <div>
    <b-row>
      <b-col
        v-for="(item, key) in itemSimpleForm"
        :key="key"
        :lg="item.col || 12"
      >
        <b-form-group
          label-cols="4"
          :label-cols-lg="item.col ? 4 : 2"
          :label="convertLabel(item, key)"
        >
          <b-input-group>
            
            <b-form-input
              v-if="item.type === 'text'"
              v-model="model[key]"
              :state="isValidation(key)"
              :aria-describedby="key"
              :style="item.col ? 'margin-left:3px' : ''"
              :disabled="item.disabled||false"
            ></b-form-input>
            <b-form-textarea
              v-else-if="item.type === 'textarea'"
              v-model="model[key]"
              :state="isValidation(key)"
              :aria-describedby="key"
              rows="3"
              max-rows="6"
              :style="item.col ? 'margin-left:3px' : ''"
              :disabled="item.disabled||false"
            ></b-form-textarea>
            <b-form-input
              v-else-if="item.type === 'date'"
              type="date"
              v-model="model[key]"
              :state="isValidation(key)"
              :aria-describedby="key"
              :style="item.col ? 'margin-left:0px' : ''"
              :disabled="item.disabled||false"
            ></b-form-input>
            <my-number
              v-else-if="item.type == 'number'"
              v-model="model[key]"
              :precision="2"
              :state="isValidation(key)"
              :aria-describedby="key"
              :disabled="item.disabled||false"
            />
            <template v-else-if="item.type == 'select'">
              <b-form-select
                v-if="
                  (item.options.filter((x) => x.value != '') || []).length > 2
                "
                v-model="model[key]"
                :options="item.options"
                :state="isValidation(key)"
                :aria-describedby="key"
              >
              </b-form-select>
              <b-form-radio-group
                v-else
                v-model="model[key]"
                :options="item.options.filter((x) => x.value != '')"
                class="mt-2"
                :state="isValidation(key)"
                :aria-describedby="key"
              ></b-form-radio-group>
            </template>
            <b-input-group-append v-if="item.append">
              <b-button @click="click(item,key)"><i :class="`fa fa-${item.append.iconfa}`"></i></b-button>
            </b-input-group-append>
          </b-input-group>

          <b-form-invalid-feedback :id="key"
            >This is a required field.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import myNumber from "./my-number.vue";
import moment from "moment";
export default {
  components: {myNumber},
  props: ["itemSimpleForm", "$v", "model"],
  created() {
    const itemSimpleForm= this.itemSimpleForm;
    for (const key in itemSimpleForm) {
      let spec = itemSimpleForm[key];
      setTimeout(() => {
        if(spec.type=='date'){
          this.model[key]=moment(this.model[key]).format('YYYY-MM-DD');
        }
      }, 500);
    }
  },
  mounted() {
  
  },
  methods: {
    isValidation(key) {
        if (this.$v.model[key]) return !this.$v.model[key].$error;
      else return true;
    },
    convertLabel(item, key) {
      let { label } = item;
      let label_ = label || key;
      if (!label) {
        let newLabel = "";
        if (label_.includes("_")) {
          let stringSplit = label_.split("_");
          stringSplit.map(string=>{
            let newString ='';
            for (let index = 0; index < string.length; index++) {
                let elt = string[index];
                elt = elt.toLowerCase();
                if(index==0){
                    elt = elt.toUpperCase();
                }
                newString+=elt;
            }
            newLabel += newLabel ? ` ${newString}`:newString;
          });
          label_ = newLabel;
        } else {
          for (let index = 0; index < label_.length; index++) {
            const element = label_[index];
            if (index == 0) {
              newLabel += element.toUpperCase();
            } else {
              if (element == element.toUpperCase()) {
                newLabel += " ";
              }
              newLabel += element;
            }
          }
        }
        label_ = newLabel;
      }

      return label_;
    },
    click(item,key){
      this.$emit(`click${item.append.name}`,{item,key});
    },
  },
};
</script>